import $ from 'jquery';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import GLightbox from 'glightbox';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Parallax from 'parallax-js'

import { $Elements, Animations, Breakpoints, BrowserEvents } from './constants';
import { fixMobileHover, getAnimationsFilteredByBreakpoints, initFacebookPixel, initGoogleAnalytics, setCookiesAllowed, setDisclaimerAccepted } from './helpers';
import { calculateMenuOffset } from './menu';

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- Fix Scroll ----------

history.scrollRestoration = "manual";

// ---------- jQuery Related ----------

$Elements.document.on(BrowserEvents.page.enter, () => {

	// ---------- Fix VH ----------

	$Elements.window.on('resize', () => document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`));
	$Elements.window.trigger('resize');

	// ---------- Fix Mobile Hover ----------

	$Elements.window.on('load', () => fixMobileHover());

	// ---------- Handle Aniamtions ----------

	ScrollTrigger.matchMedia(getAnimationsFilteredByBreakpoints(Animations));

	// ---------- Links ----------

	$Elements.body.on('click', 'a[href="#"], .void-link', (e) => e.preventDefault());

	$Elements.body.on('click', '[data-scroll-to], [target="scroll-to"]', function(e) {
		e.preventDefault();

		const self = $(this);
		const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

		if(target.length) {

			$('html, body').stop().animate({
				scrollTop: calculateMenuOffset(target)
			}, 1000);
		}
	});

	$Elements.body.on('click', '.select-dropdown .dropdown-menu .btn', function() {
		$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
	});

	$Elements.body.on('click', 'svg.custom-map .map-link', function() {
		window.location.href = $(this).attr('data-url');
	});

	// ---------- GLightbox ----------

	$('[target="lightbox"]').each(function() {

		GLightbox({
			selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"]',
			openEffect: 'fade',
			closeEffect: 'fade',
			videosWidth: 1280,
		});
	});

	$('[target^="lightbox-gallery"]').each(function() {

		GLightbox({
			selector: 'a[target="' + this.attributes.target.value + '"]',
			openEffect: 'fade',
			closeEffect: 'fade',
			videosWidth: 1280,
		});
	});

	// ---------- Disclaimer ----------

	$('#disclaimer').on('closed.bs.alert', function() {
		setDisclaimerAccepted();
		$Elements.body.removeClass('disclaimer-open');
	});

	// ---------- Cookies ----------

	$('#cookies-allowed').on('click', '[data-dismiss="alert"]', function() {
		setCookiesAllowed(this.dataset.allowed);
		$Elements.window.trigger('cookies-allowed');
	});

	$Elements.window.on('cookies-allowed load', function() {
		initGoogleAnalytics();
		initFacebookPixel();
	});

	// ---------- Home Animation ----------

	let mouseLeaveAnimations;

	function addMouseInAnimations() {
		$Elements.body.removeClass('mouse-out');
		$Elements.body.addClass('mouse-in');
	}

	$Elements.window.on('mouseleave', function() {
		clearTimeout(mouseLeaveAnimations);

		mouseLeaveAnimations = setTimeout(
			function() {
				$Elements.body.removeClass('mouse-in');
				$Elements.body.addClass('mouse-out');
			}, 3000
		);
	});

	$Elements.window.on('mouseenter', function() {
		clearTimeout(mouseLeaveAnimations);
		addMouseInAnimations()
	});

	$Elements.window.on('load', function() {
		setTimeout(function() {
			$('body').addClass('mouse-in');
		}, 1500)
	});

	// ---------- Parallax.js ----------

	$('.parallax-content').each(function() {

		const self = $(this);
		const scene = new Parallax(this, {
			relativeInput: true
		});

		self.on('slide.active', function() {
			scene.parallax('enable');
		});

		self.on('slide.inactive', function() {
			scene.parallax('disable');
		});

	});

	// ---------- Wines List pre-open if clicked from a Marque page ("taxonomy-marque.php") ----------

	$('.wines-list-wrapper').each(function() {
		const self = $(this);
		const activeSlug = self.find('#slug-active').val();

		if(activeSlug.length) {
			const activeElement = self.find(`[data-slug='${activeSlug}']`);

			if(window.innerWidth < Breakpoints.mobile) {
				activeElement.find('ul.first-sublist').addClass('active');
				activeElement.parents('section.list-content-section').addClass('first-sublist-open');

			} else {
				activeElement.addClass('active');
				activeElement.find('ul.first-sublist').addClass('active');
			}
		}
	});

});
